import { PropsWithChildren } from 'react';
import { useSession } from '@/components/session/useSession';
import { UnavailablePageForEconomicUnits } from '@/components/Unavailable';

/**
 * Guards the routes that only exist while the org has economic units switched on. The nav hides
 * those entries when the preference is off, so a URL is the only way in — and it has to explain the
 * missing configuration instead of rendering a page the org has not enabled.
 */
export function EconomicUnitsRoutingGuard({ children }: PropsWithChildren) {
  const {
    org: { isEconomicUnitsToggled },
  } = useSession();

  if (!isEconomicUnitsToggled) {
    return <UnavailablePageForEconomicUnits />;
  }

  return <>{children}</>;
}
